// React 入口：挂载根组件到 #root。产物经 Vite 打包为 public/app.js。
import { createRoot } from "react-dom/client";
import { App } from "./views/App";
import ibmPlexSansCss from "@fontsource-variable/ibm-plex-sans/index.css?inline";
import notoSansScCss from "@fontsource-variable/noto-sans-sc/index.css?inline";

const fontStyles = document.createElement("style");
fontStyles.dataset.vsignFonts = "ibm-plex-sans-noto-sans-sc";
fontStyles.textContent = `${ibmPlexSansCss}\n${notoSansScCss}`;
document.head.append(fontStyles);

const container = document.getElementById("root");
if (container) {
  createRoot(container).render(<App />);
}
